import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Modal, Button, Row, Col } from 'react-bootstrap';
import Select from 'react-select';
import { fetchUsers } from '../../store/actions/users/usersActions';
import { toggleDialogBox } from '../../store/actions/commonActions';
import { handleFieldChange } from '../../store/actions/projects/projectsActions';
import { addProjectMembers } from '../../store/actions/projects/projectMembersActions';
import ProjectMembers from './ProjectMembers';

class ManageMembers extends Component {
  
  componentDidMount() {
    this.props.fetchUsers();
  }

  addMembersForm = () => {
    let userOptions = [];
    const users = this.props.users.users;
    const projectMembers = this.props.projects.projectMembers;

    let arrProjectMembers = [];

    if (projectMembers) {
      projectMembers.forEach(projectMember => {
        if (typeof(projectMember.user) !== "undefined") {
          const user = projectMember.user;
          if (user) {
            arrProjectMembers.push(user.id);
          }
        }
      });
    }

    let selectedValues = ''

    if (typeof(this.props.projects.project.selectedMembers) !== "undefined") {
      selectedValues = this.props.projects.project.selectedMembers;
    }

    userOptions = users.length > 0 && users.filter(data => {
      if (!arrProjectMembers.includes(data.id)) {
        return data;
      }
      return null;
    }).map((user) => {
      return {
        label: user.first_name + " " + user.last_name, 
        value: user.id
      }
    })

    return (
      <Row className="mt-3 ml-3 mr-3">
        <Col xs={10} sm={10} md={10} lg={10} xl={10}>
          <Select
            isSearchable={true}
            name="team_members" 
            isMulti={true} 
            value={selectedValues}
            options={userOptions} 
            onChange={(values) => {

              this.props.handleFieldChange(null, {
                selectedMembers: values 
              });

              let arrTeamMembers = [];
              if (values) { 
                values.forEach(option => {
                  arrTeamMembers.push(option.value);
                });
              }

              this.props.handleFieldChange(null, {
                team_members: arrTeamMembers 
              });
            }}
          />
        </Col>
        <Col xs={2} sm={2} md={2} lg={2} xl={2}>
          <Button variant="primary" onClick={() => {
            this.props.addProjectMembers();
          }}>Add</Button>
        </Col>
      </Row>
    )
  }

  render() {
    return (
      <Modal id="t3-manage-members-modal" show={this.props.common.toggleDialog} onHide={() => {
        this.props.toggleDialogBox(false);
        
      }} backdrop="static">
        <Modal.Header closeButton>
            <Modal.Title>Manage Members</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          { this.addMembersForm() }
          <Row className="ml-3">
            <Col xs={12} sm={12} md={12} lg={12} xl={12}>
              <ProjectMembers isManageable={true}/>
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer>
            <Button variant="secondary" onClick={() => {
              this.props.toggleDialogBox(false);
            }}>
                Close
            </Button>
        </Modal.Footer>
      </Modal>
    )
  }
}

const mapStateToProps = (state) => ({
  projects: state.projects, 
  users: state.users, 
  common: state.common 
})

const mapDispatchToProps = (dispatch) => {
  return {
    fetchUsers: () => dispatch(fetchUsers()),
    toggleDialogBox: (...args) => dispatch(toggleDialogBox(...args)),
    handleFieldChange: (...args) => dispatch(handleFieldChange(...args)),
    addProjectMembers: () => dispatch(addProjectMembers())
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ManageMembers)
